import api from './api';

export interface KnrInfo {
  opis: string | null;
  jm: string | null;
}

export const fetchKnrInfo = async (knr: string, symbol: string): Promise<KnrInfo> => {
  const response = await api.get<KnrInfo>('/knr/info', {
    params: { knr, symbol }
  });
  return response.data;
};

export interface KnrRmsRowDto {
  naklad_typ: string;
  naklad_naz: string;
  naklad_jmn: string;
  norma: string;
}

export const fetchKnrRms = async (knr: string, symbol: string): Promise<KnrRmsRowDto[]> => {
  const response = await api.get<{ rows: KnrRmsRowDto[] }>('/knr/rms', {
    params: { knr, symbol }
  });
  return response.data.rows ?? [];
}; 